<template>
  <div class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Výrobci - seznam</strong>
      </div>
      <action-tools :router-options="routerOptions" :handle-refresh="handleRefresh"></action-tools>
    </div>
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-md-6">
          <a-dropdown :placement="'bottomLeft'">
            <a-button>Hromadné akce
              <a-icon type="down"/>
            </a-button>
            <a-menu slot="overlay">
              <a-menu-item :disabled="selectedRowKeys.length === 0" :class="{'disabled': selectedRowKeys.length === 0}">
                <a-popconfirm @confirm="confirmDelete(selectedRowKeys)" okText="Potvrdit" cancelText="Zrušit">
                  <template slot="title">
                    <p>Opravdu si přejete odstranit tyto položky?</p>
                    <div v-if="selectedRowKeys.length > 0">
                      {{ selectedRowKeys }}
                    </div>
                  </template>
                  Odstranit
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
        <div class="text-right col-md-6">
          <a-input-search
            placeholder="Hledat..."
            style="width: 200px"
            @search="handleSearch"
          />
        </div>
      </div>
      <a-table
        tableLayout="auto"
        :rowSelection="rowSelection"
        :rowKey="record => record.mur_id"
        :columns="columns"
        :loading="loading"
        :dataSource="manufacturers"
        class="utils__scrollTable"
        :scroll="{ x: '100%' }"
      >
        <router-link
          slot="mur_id"
          slot-scope="value"
          class="utils__link--underlined"
          :to="'/ecommerce/manufacturer/detail/' + value"
        >#<span v-if="searchText">
            <template
              v-for="(fragment, i) in value.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
              <mark
                v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                :key="i"
                class="highlight"
              >{{fragment}}</mark>
              <template v-else>{{fragment}}</template>
            </template>
          </span>
          <template v-else>{{value}}</template>
        </router-link>
        <template slot="customRender" slot-scope="text">
          <span v-if="searchText && text !== null">
            <template
              v-for="(fragment, i) in text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
              <mark
                v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                :key="i"
                class="highlight"
              >{{fragment}}</mark>
              <template v-else>{{fragment}}</template>
            </template>
          </span>
          <template v-else>{{text}}</template>
        </template>
        <span slot="products_count" slot-scope="text">
          <ion-icon name="logo-apple" class="mr-2"></ion-icon>
          <span v-if="searchText">
            <template
              v-for="(fragment, i) in text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
              <mark
                v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                :key="i"
                class="highlight"
              >{{fragment}}</mark>
              <template v-else>{{fragment}}</template>
            </template>
          </span>
          <template v-else>{{text}}</template>
        </span>
        <span
          slot="image"
          slot-scope="record"
          :class="$style.thumbnail"
        >
          <img v-if="record !== null && !image.errors.includes(record.iae_id)" :src="$uploadImagePath + record.iae_path + '_10.' + record.iae_format" @error="image.errors.push(record.iae_id)">
          <a-icon v-else theme="twoTone" twoToneColor="#ccc" type="frown" />
        </span>
        <span slot="action" slot-scope="record">
          <router-link :to="'/ecommerce/manufacturer/detail/'+record.mur_id">
            <a-button icon="search" size="small" class="mr-1">Zobrazit</a-button>
          </router-link>
          <a-popconfirm @confirm="confirmDelete([record.mur_id])" okText="Potvrdit" cancelText="Zrušit">
            <template slot="title">
                <p>Opravdu si přejete odstranit položku: #{{ record.mur_id }} ?</p>
            </template>
            <a-button icon="delete" size="small">Odstranit</a-button>
          </a-popconfirm>
        </span>
        <template slot="footer">
          {{ manufacturers.length }} položek
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import ActionTools from '@/components/MyComponents/ActionTools'

export default {
  components: { ActionTools },
  data: function () {
    return {
      image: {
        errors: [],
      },
      searchText: '',
      loading: false,
      selectedRowKeys: [],
      routerOptions: [
        {
          icon: 'plus-circle',
          to: '/ecommerce/manufacturer/add',
          title: 'Přidat',
        },
      ],
      columns: [
        {
          title: 'ID',
          dataIndex: 'mur_id',
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.mur_id - b.mur_id,
          scopedSlots: {
            customRender: 'mur_id',
          },
        },
        {
          title: 'Obrázek',
          dataIndex: 'image',
          scopedSlots: {
            customRender: 'image',
          },
        },
        {
          title: 'Název',
          dataIndex: 'mur_name',
          sorter: (a, b) => {
            return a.mur_name.localeCompare(b.mur_name)
          },
          scopedSlots: {
            customRender: 'customRender',
          },
        },
        {
          title: 'URL',
          dataIndex: 'mur_url',
          sorter: (a, b) => {
            return a.mur_url !== null && b.mur_url !== null ? a.mur_url.localeCompare(b.mur_url) : ''
          },
          scopedSlots: {
            customRender: 'customRender',
          },
        },
        {
          title: 'Počet produktů',
          dataIndex: 'products_count',
          sorter: (a, b) => a.products_count - b.products_count,
          scopedSlots: {
            customRender: 'products_count',
          },
        },
        {
          title: 'Akce',
          key: 'action',
          scopedSlots: {
            customRender: 'action',
          },
        },
      ],
    }
  },
  computed: {
    manufacturers: function () {
      return this.$store.getters['manufacturer/filteredItems'](this.searchText)
    },
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        selections: [{
          key: 'all-data',
          text: 'Vybrat všechny položky',
          onSelect: () => {
            this.selectedRowKeys = this.selectedRowKeys.length === 0 ? this.manufacturers.map(item => item.mur_id) : []
          },
        }],
        onSelection: this.onSelection,
      }
    },
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleRefresh() {
      this.loading = true
      this.$store.dispatch('manufacturer/getList')
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    confirmDelete(manufacturers) {
      this.loading = true
      this.$store.dispatch('manufacturer/delete', manufacturers)
        .then(() => {
          if (this.selectedRowKeys.length > 0) {
            this.selectedRowKeys = manufacturers.filter(x => !this.selectedRowKeys.includes(x))
              .concat(this.selectedRowKeys.filter(x => !manufacturers.includes(x)))
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    handleSearch(searchText) {
      this.searchText = searchText
    },
  },
  created() {
    if (this.manufacturers.length === 0) {
      this.handleRefresh()
    }
  },
}
</script>

<style lang="scss" module scoped>
  @import "./style.module.scss";
</style>
